/** Zählt Garantie- und Kulanz-Fälle nach aktiv / archiviert. */
export function emptyFalltypAktivArchiv() {
  return {
    GARANTIE: { aktiv: 0, archiv: 0 },
    KULANZ: { aktiv: 0, archiv: 0 },
  };
}

export function countFalltypAktivArchiv(items) {
  const counts = emptyFalltypAktivArchiv();
  for (const a of items || []) {
    const ft = String(a.falltyp || "NORMAL").toUpperCase();
    if (!(ft in counts)) continue;
    const arch = a._arch === true || a.archiviert === true;
    if (arch) counts[ft].archiv += 1;
    else counts[ft].aktiv += 1;
  }
  return counts;
}

export function aggregateFalltypGroupedRows(rows) {
  const counts = emptyFalltypAktivArchiv();
  for (const r of rows || []) {
    const ft = String(r.falltyp || r.ft || "NORMAL").toUpperCase();
    if (!(ft in counts)) continue;
    const n = Number(r.c ?? r.count ?? 0);
    const arch =
      r.archiviert === true ||
      r.arch === true ||
      Number(r.is_arch) === 1 ||
      r.archiviert === "t" ||
      r.archiviert === "true";
    if (arch) counts[ft].archiv += n;
    else counts[ft].aktiv += n;
  }
  return counts;
}

export function formatAktivArchiviertPair(aktiv, archiv) {
  return `${Number(aktiv) || 0} aktiv · ${Number(archiv) || 0} archiviert`;
}

export function formatFalltypAktivArchivHeader(stats, totals = {}) {
  const g = stats?.GARANTIE || { aktiv: 0, archiv: 0 };
  const k = stats?.KULANZ || { aktiv: 0, archiv: 0 };
  const falltypTitle = `Garantie: ${formatAktivArchiviertPair(g.aktiv, g.archiv)} · Kulanz: ${formatAktivArchiviertPair(k.aktiv, k.archiv)}`;
  const aktiv = totals.aktiv;
  const archiv = totals.archiv;
  if (Number.isFinite(Number(aktiv)) && Number.isFinite(Number(archiv))) {
    const pair = formatAktivArchiviertPair(aktiv, archiv);
    return {
      short: pair,
      title: `Service: ${pair} · ${falltypTitle}`,
    };
  }
  return {
    short: `Garantie ${g.aktiv}·${g.archiv} · Kulanz ${k.aktiv}·${k.archiv}`,
    title: falltypTitle,
  };
}
